import $ from 'jquery';
/* global ajaxPath */

const mapLogic = {
  newMap: ($el) => {
    const $markers = $el.find('.marker');

    const args = {
      zoom: 16,
      center: new window.google.maps.LatLng(0, 0),
      mapTypeId: window.google.maps.MapTypeId.ROADMAP,
      styles: [
        {
          featureType: 'landscape',
          elementType: 'geometry',
          stylers: [
            {
              saturation: '-100',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.stroke',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'labels.text',
          stylers: [
            {
              color: '#545454',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'labels.text.stroke',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [
            {
              saturation: '-87',
            },
            {
              lightness: '-40',
            },
            {
              color: '#ffffff',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road.highway.controlled_access',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#f0f0f0',
            },
            {
              saturation: '-22',
            },
            {
              lightness: '-16',
            },
          ],
        },
        {
          featureType: 'road.highway.controlled_access',
          elementType: 'geometry.stroke',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road.highway.controlled_access',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'on',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry.stroke',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'geometry.stroke',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [
            {
              saturation: '-52',
            },
            {
              hue: '#00e4ff',
            },
            {
              lightness: '-16',
            },
          ],
        },
      ],
    };

    // create map
    const map = new window.google.maps.Map($el[0], args);

    // add a markers reference
    map.markers = [];

    // add markers
    $markers.each(function () {
      // eslint-disable-next-line no-undef
      mapLogic.addMarker($(this), map);
    });

    // center map
    // eslint-disable-next-line no-undef
    mapLogic.centerMap(map);

    // return
    return map;
  },

  /*
   *  add_marker
   *
   *  This function will add a marker to the selected Google Map
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	4.3.0
   *
   *  @param	$marker (jQuery element)
   *  @param	map (Google Map object)
   *  @return	n/a
   */
  addMarker: ($marker, map) => {
    // var
    const latlng = new window.google.maps.LatLng(
      $marker.attr('data-lat'),
      $marker.attr('data-lng')
    );

    const imageIcon = {
      url: ajaxPath.theme_folder + '/assets/images/icons/map-pin.png',
    };

    // create marker
    const marker = new window.google.maps.Marker({
      position: latlng,
      map,
      icon: imageIcon,
    });

    // add to array
    map.markers.push(marker);

    // if marker contains HTML, add it to an infoWindow
    if ($marker.html()) {
      // create info window
      const infowindow = new window.google.maps.InfoWindow({
        content: $marker.html(),
      });

      // show info window when marker is clicked
      window.google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker);
      });
    }
  },

  /*
   *  center_map
   *
   *  This function will center the map, showing all markers attached to this map
   *
   *  @type	function
   *  @date	8/11/2013
   *  @since	4.3.0
   *
   *  @param	map (Google Map object)
   *  @return	n/a
   */
  centerMap: (map) => {
    const bounds = new window.google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each(map.markers, function (i, marker) {
      const latlng = new window.google.maps.LatLng(marker.position.lat(), marker.position.lng());

      bounds.extend(latlng);
    });

    // only 1 marker?
    if (map.markers.length === 1) {
      // set center of map
      map.setCenter(bounds.getCenter());

      map.setZoom(16);
    } else {
      // fit to bounds
      map.fitBounds(bounds);
    }
  },
};

export default mapLogic;
